import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSettings } from "@/contexts/SettingsContext";
import { Phone, MessageCircle, MapPin, CalendarCheck } from "lucide-react";

export default function MobileActionBar() {
  const { t } = useTranslation();
  const { settings: s } = useSettings();
  if (!s) return null;

  const phone = (s.phone || "").replace(/\s/g, "");
  const wa = s.whatsapp_raw;

  const items = [
    { icon: Phone, label: t("mobile_bar.call"), href: `tel:${phone}`, ext: true, tid: "mbar-call" },
    { icon: MessageCircle, label: t("mobile_bar.whatsapp"), href: `https://wa.me/${wa}`, ext: true, tid: "mbar-whatsapp" },
    { icon: MapPin, label: t("mobile_bar.directions"), href: s.maps_url, ext: true, tid: "mbar-directions" },
    { icon: CalendarCheck, label: t("mobile_bar.reserve"), to: "/reservation", ext: false, tid: "mbar-reserve" },
  ];

  return (
    <div
      data-testid="mobile-action-bar"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#050505]/95 backdrop-blur-xl border-t border-[#D4AF37]/25"
    >
      <div className="grid grid-cols-4">
        {items.map((it, idx) => {
          const Icon = it.icon;
          const inner = (
            <div className="flex flex-col items-center justify-center py-3 gap-1 text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-colors">
              <Icon size={18} />
              <span className="text-[10px] tracking-[0.18em] uppercase text-[#F8F5EF]/90">{it.label}</span>
            </div>
          );
          return it.ext ? (
            <a key={idx} href={it.href} target={it.href?.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={it.tid}>{inner}</a>
          ) : (
            <Link key={idx} to={it.to} data-testid={it.tid}>{inner}</Link>
          );
        })}
      </div>
    </div>
  );
}
